import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { opacity } from '../utils/customPropStyles';
import Icon from './Icon';
import { SORT_DIRECTIONS } from '../constants';

const SortToggleButton = styled<any, any>('button')`
    ${propStyles};
    ${opacity};
    outline: none;
`;

SortToggleButton.defaultProps = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    bgColor: "transparent",
    borderStyle: "none",
    cursor: "pointer"
};

interface SortToggleProps {
    theme?: { [property: string]: string | number };
    direction: 'ASC' | 'DESC' | undefined;
    disabled?: boolean;
    onClick(): void;
}

export const SortToggle: React.SFC<SortToggleProps> = ({ theme, direction, ...props }) => {
    const fileName = (direction === SORT_DIRECTIONS.ASC) 
                        ? 'ColumnSortAscIcon' 
                        : (direction === SORT_DIRECTIONS.DESC) 
                        ? 'ColumnSortDescIcon' 
                        : 'ColumnSortOffIcon';
    const selected = (direction === SORT_DIRECTIONS.ASC) || (direction === SORT_DIRECTIONS.DESC);

    return (
        <SortToggleButton
            data-selected={selected}
            opacity={selected ? "1" : "0.25"}
            {...theme.SortToggle}
            {...props}
        >
            <Icon
                fileName={fileName}
            />
        </SortToggleButton>
    );
};

export default withTheme(observer(SortToggle)) as any;


// WEBPACK FOOTER //
// ./src/Components/SortToggle.tsx